import { updateComponentStyle } from './update-component-style';
import { updateComponentData } from './update-component-data';
import { updateImageProperties, updateMultipleImageProperties } from './helpers/update-image-properties';
export const dsStudioDataModifier = {
  updateTextColor: (component, color) => updateComponentStyle(component, {
    color
  }),
  updateBackgroundColor: (component, bgColor) => updateComponentStyle(component, {
    bgColor
  }),
  updateTextAndBackgroundColor: (component, color, bgColor) => updateComponentStyle(component, {
    color,
    bgColor
  }),
  updateTextHeadingLevel: (component, newTag) => updateComponentData(component, newTag),
  updateImageProperties,
  updateMultipleImageProperties
};
//# sourceMappingURL=ds-studio-data-modifier.js.map